import React from 'react';

export interface TableElement {
    category: string;
    winner: string
}

interface Props {
    tableElements: TableElement[];
    date: string
}

export const TournamentTable = (props: Props) => {
    return (
        <section className={'ttc-list'}>
            <header className={'ttc-list-head'}>
                <span>Reeksen {props.date}</span>
                <span>Winnaar</span>
            </header>
            {props.tableElements.map((element, idx) => (
                <div className={'ttc-list-row'} key={idx}>
                    <span className={'ttc-list-label'}>{element.category}</span>
                    <span className={'ttc-list-value'}>{element.winner}</span>
                </div>
            ))}
        </section>
    )
}
